import 'rxjs/add/operator/map';

export interface CardImages {
  front: string;
  back: string;
}

export interface Card {
  images: CardImages;
  metadatas: any;
}

export interface Cards {
  [key: string]: Card[];
}

export enum TokenTemplates {
  EMPTY = 'EMPTY',
  SIMPLE_GREEN = 'SIMPLE_GREEN',
  SIMPLE_YELLOW = 'SIMPLE_YELLOW',
  SIMPLE_RED = 'SIMPLE_RED',
  STUNT = 'STUNT',
  ENRAGE = 'ENRAGE',
  WARD = 'WARD'
}
